
let language = {
    STANDARD_COMPLETE_PAYMENT_SUCCEED_TITLE: "Payment Succeed",

    STANDARD_COMPLETE_PAYMENT_TIME_TIP1: "This page will automatically jump to \"My Order\" in",
    STANDARD_COMPLETE_PAYMENT_TIME_TIP2: "seconds",

    STANDARD_COMPLETE_BACK_ORDER_BTN: "Back to My Order",
    STANDARD_COMPLETE_CONTINUE_SHOPPING_BTN: "Continue Shopping",

    STANDARD_COMPLETE_URL_PARAM_CHECK_ALERT_TITLE: "Warning",
    STANDARD_COMPLETE_URL_PARAM_CHECK_ALERT_CONTENT: "Lack Order Id",
};

export { language }